import React from 'react';
import { Component } from './component';
import { TITLE } from './constant';

export const Container: React.FC<{title?: TITLE}> = ({title}) => {
  return <Component title={title}/>;
};
